module.exports = [{
      plugin: require('/codebuild/output/src444008828/src/bitbucket.org/cleanslate/indy-steel-static/client-source/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/styles/typography"},
    },{
      plugin: require('/codebuild/output/src444008828/src/bitbucket.org/cleanslate/indy-steel-static/client-source/node_modules/gatsby-plugin-modal-routing/gatsby-browser.js'),
      options: {"plugins":[],"appElement":"#___gatsby","modalProps":{}},
    },{
      plugin: require('/codebuild/output/src444008828/src/bitbucket.org/cleanslate/indy-steel-static/client-source/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
